import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // Update state with error details
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReset = () => {
    // Get user role from localStorage
    const user = localStorage.getItem('user');
    let redirectPath = '/user/login'; // Default fallback

    if (user) {
      try {
        const userData = JSON.parse(user);
        const roles = userData.roles || [];
        
        // Check if user is a health care provider
        if (roles.some(role => role.roleType === 'HEALTH_CARE_PROVIDER')) {
          redirectPath = '/hcp/patient/list';
        }
        // Check if user is an admin
        else if (roles.some(role => role.roleType === 'ORG_ADMIN')) {
          redirectPath = '/admin/clinicalsites';
        }
        // Check if user is a patient
        else if (roles.some(role => role.roleType === 'PATIENT')) {
          redirectPath = '/patient';
        }
        // Check if user is family
        else if (roles.some(role => role.roleType === 'FAMILY')) {
          redirectPath = '/family';
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
        redirectPath = '/user/login';
      }
    }

    // Redirect to appropriate page
    window.location.href = redirectPath;
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          fontFamily: 'Arial, sans-serif',
          backgroundColor: '#f8f9fa',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ maxWidth: '500px' }}>
            <h2 style={{ color: '#dc3545', marginBottom: '20px' }}>
              Something went wrong
            </h2>
            <p style={{ color: '#6c757d', marginBottom: '30px' }}>
              An unexpected error occurred. Please try navigating back to your dashboard.
            </p>
            <button 
              onClick={this.handleReset}
              style={{
                backgroundColor: '#50A193',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              Go to Dashboard
            </button>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{ marginTop: '20px', textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer', color: '#50A193' }}>
                  Error Details (Development)
                </summary>
                <pre style={{ 
                  backgroundColor: '#f8f9fa', 
                  padding: '15px', 
                  borderRadius: '4px',
                  overflow: 'auto',
                  fontSize: '12px',
                  marginTop: '10px'
                }}>
                  {this.state.error && this.state.error.toString()}
                  <br />
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
